// src/services/announcements.js
// Saf API çağrıları; requestFn parametresi useApiService içinden (executeGet/Post/Patch).

export const listAdminAnnouncements = (requestFn, params = {}) =>
  requestFn({ url: '/api/admin/announcements', params });

export const createAnnouncement = (postFn, payload) =>
  postFn({ url: '/api/admin/announcements', data: payload });

export const updateAnnouncement = (patchFn, id, payload) =>
  patchFn({ url: `/api/admin/announcements/${id}`, data: payload });

export const publishAnnouncement = (postFn, id) =>
  postFn({ url: `/api/admin/announcements/${id}/publish` });

export const archiveAnnouncement = (postFn, id) =>
  postFn({ url: `/api/admin/announcements/${id}/archive` });

export const listAnnouncementCategories = (getFn) =>
  getFn({ url: '/api/admin/announcement-categories' });

export const createAnnouncementCategory = (postFn, payload) =>
  postFn({ url: '/api/admin/announcement-categories', data: payload });

export const updateAnnouncementCategory = (patchFn, id, payload) =>
  patchFn({ url: `/api/admin/announcement-categories/${id}`, data: payload });

export const deleteAnnouncementCategory = (deleteFn, id) =>
  deleteFn({ url: `/api/admin/announcement-categories/${id}` });

export const listPublishedAnnouncements = (getFn, params = {}) =>
  getFn({ url: '/api/announcements', params });

export const getAnnouncementBySlug = (getFn, slug) =>
  getFn({ url: `/api/announcements/${slug}` });
